// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
import Moment from 'moment'

class RouteViolationRecord extends VerofreshRecord {
  static get TYPE_COLD () { return 'cold' }
  static get TYPE_HOT () { return 'hot' }
  static get TYPE_NODATA () { return 'no-data' }
  static get TYPE_GPS_GAP () { return 'gps-gap' }
  static get TYPE_GAP () { return 'time-gap' }
  static get TYPE_MISSED_STOP () { return 'missed-stop' }
  static get TYPE_SET_POINT_NOT_REACHED () { return 'set-point-not-reached' }
  static get TYPE_NOMINAL_AIR_TEMP_NOT_REACHED () { return 'nominal-air-temp-not-reached' }
  static get TYPE_SWAPPED_AIR_SENSORS () { return 'swapped-air-sensors' }

  static get LEVEL_WARNING () { return 'warning' }
  static get LEVEL_FATAL () { return 'fatal' }
  static get LEVEL_INFO () { return 'info' }
  static get LEVEL_FORECAST () { return 'forecast' }
  static get LEVEL_FORECAST_STAGING () { return 'forecast_staging' }

  static get types () {
    return [
      RouteViolationRecord.TYPE_COLD,
      RouteViolationRecord.TYPE_HOT,
      RouteViolationRecord.TYPE_NODATA,
      RouteViolationRecord.TYPE_GPS_GAP,
      RouteViolationRecord.TYPE_GAP,
      RouteViolationRecord.TYPE_MISSED_STOP,
      RouteViolationRecord.TYPE_SET_POINT_NOT_REACHED,
      RouteViolationRecord.TYPE_NOMINAL_AIR_TEMP_NOT_REACHED,
      RouteViolationRecord.TYPE_SWAPPED_AIR_SENSORS
    ]
  }

  static get levels () {
    return [
      RouteViolationRecord.LEVEL_WARNING,
      RouteViolationRecord.LEVEL_FATAL,
      RouteViolationRecord.LEVEL_INFO,
      RouteViolationRecord.LEVEL_FORECAST,
      RouteViolationRecord.LEVEL_FORECAST_STAGING
    ]
  }

  static get DEFAULT_NOMINAL_COOLER_TEMPERATURE () {
    return 4.4444 // 40°F
  }

  static get DEFAULT_NOMINAL_FREEZER_TEMPERATURE () {
    return -12.2222 // 10°F
  }

  /**
   * Returns the route duration in seconds.
   *
   * @return int
   */
  get duration () {
    const start = Moment(this.start)
    let end = Moment(this.end)

    if (start.isBefore() && !end.isValid()) {
      end = Moment()
    }

    if (!start.isValid() || !end.isValid()) {
      return undefined
    }

    return end.diff(start, 'seconds')
  }

  /**
   * Returns an icon to display for the Route Violation's type
   */
  get mdiIcon () {
    switch (this.type) {
      case RouteViolationRecord.TYPE_COLD:
        return 'mdi-snowflake-alert'
      case RouteViolationRecord.TYPE_HOT:
        return 'mdi-fire-alert'
      case RouteViolationRecord.TYPE_GAP:
        return 'mdi-timer-alert'
      case RouteViolationRecord.TYPE_NODATA:
        return 'mdi-cancel'
      case RouteViolationRecord.TYPE_GPS_GAP:
        return 'mdi-map-marker-alert'
      case RouteViolationRecord.TYPE_MISSED_STOP:
        return 'mdi-alert-octagon'
      case RouteViolationRecord.TYPE_NOMINAL_AIR_TEMP_NOT_REACHED:
        return 'mdi-thermometer-alert'
      case RouteViolationRecord.TYPE_SET_POINT_NOT_REACHED:
        return 'mdi-thermometer-alert'
      case RouteViolationRecord.TYPE_SWAPPED_AIR_SENSORS:
        return 'mdi-sync-alert'
      default:
        return 'mdi-alert'
    }
  }
}

const relations = {
  belongsTo: {
    RouteProduct: {
      foreignKey: 'route_product_id',
      localField: 'route_product'
    },
    Route: {
      foreignKey: 'route_id',
      localField: 'route'
    }
  }
}

export default RouteViolationRecord
export { relations }
